var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19H22.5L11.5 0L0.5 19ZM12.5 16H10.5V14H12.5V16ZM12.5 12H10.5V8H12.5V12Z",
    fill: "#232A58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIconBlack);
export default __webpack_public_path__ + "static/media/priority-icon-black.a98ee3c0d4e39a074845e91e2c302dec.svg";
export { ForwardRef as ReactComponent };